import { createSlice } from "@reduxjs/toolkit";
import { APP_STATUS } from "utils/Constants";
import { AppStatusType } from "utils/Types";

type AppStatusSliceType = {
  status: AppStatusType;
};
const initialState: AppStatusSliceType = {
  status: APP_STATUS.LIVE
};
export const AppStatusSlice = createSlice({
  name: "app-status",
  initialState,
  reducers: {
    setMaintenance: state => {
      state.status = APP_STATUS.MAINTENANCE;
    },
    clearMaintenance: state => {
      state.status = APP_STATUS.LIVE;
    }
  }
});

export const { setMaintenance, clearMaintenance } = AppStatusSlice.actions;

export default AppStatusSlice.reducer;
